/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit HelpMessageReceived.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-300.js"
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Text = css({label: 'Text',
  marginRight: 4,
marginBottom: 4,
textAlign: "center",
fontFamily: "WonderUnitSans",
fontSize: 16,
fontWeight: 300})
styles.Text1 = css({label: 'Text1',
  marginRight: 4,
marginBottom: 4,
textAlign: "center",
fontFamily: "WonderUnitSans",
fontSize: 16,
fontWeight: 300})

export default function HelpMessageReceived({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/Auth/GetHelp/HelpMessageReceived"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<span
 data-testid="HelpMessageReceived.Text"
 data-view-path="/App/Auth/GetHelp/HelpMessageReceived"
 className={`views-text ${styles.Text}`}
>
Thank you!
</span>
<span
 data-testid="HelpMessageReceived.Text:1"
 data-view-path="/App/Auth/GetHelp/HelpMessageReceived"
 className={`views-text ${styles.Text1}`}
>
We have received your message.
</span>
{children}
</React.Fragment>)
}